import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: ':tableToken',
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
      },
      {
        path: 'join-user',
        loadChildren: () => import('./join-user/join-user.module').then( m => m.JoinUserPageModule)
      },
      {
        path: 'item-detail',
        loadChildren: () => import('./item-detail/item-detail.module').then( m => m.ItemDetailPageModule)
      },
      {
        path: 'item-preview',
        loadChildren: () => import('./item-preview/item-preview.module').then( m => m.ItemPreviewPageModule)
      },
      {
        path: 'cart-view',
        loadChildren: () => import('./cart-view/cart-view.module').then( m => m.CartViewPageModule)
      },
      {
        path: 'order-process',
        loadChildren: () => import('./order-process/order-process.module').then( m => m.OrderProcessPageModule)
      },
      {
        path: 'confirm-order-modal',
        loadChildren: () => import('./confirm-order-modal/confirm-order-modal.module').then( m => m.ConfirmOrderModalPageModule)
      },
      {
        path: 'order-summary',
        loadChildren: () => import('./order-summary/order-summary.module').then( m => m.OrderSummaryPageModule)
      },
      {
        path: 'order-confirm',
        loadChildren: () => import('./order-confirm/order-confirm.module').then( m => m.OrderConfirmPageModule)
      },
      {
        path: 'order-payment',
        loadChildren: () => import('./order-payment/order-payment.module').then( m => m.OrderPaymentPageModule)
      },
      {
        path: 'order-success',
        loadChildren: () => import('./order-success/order-success.module').then( m => m.OrderSuccessPageModule)
      },
      {
        path: 'pay-cashier',
        loadChildren: () => import('./pay-cashier/pay-cashier.module').then( m => m.PayCashierPageModule)
      },
      {
        path: 'history',
        loadChildren: () => import('./history/history.module').then( m => m.HistoryPageModule)
      },
      {
        path: 'privacy-policy',
        loadChildren: () => import('./privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule)
      },
      {
        path: 'table-not-found',
        loadChildren: () => import('./table-not-found/table-not-found.module').then( m => m.TableNotFoundPageModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
